import AccountsPage from "../Accounts/AccountsPage";

export default AccountsPage;
